// test2749
(2749 && 0);
